import { simpleSet } from '@r/reducers/utils';

const setRightSideCabinetMenuOpen = simpleSet as
  redux.reducers.flags.rightSideCabinetMenuMode;
export const rightSideCabinetMenuMode = setRightSideCabinetMenuOpen(
  'SET_RIGHT_SIDE_CABINET_MENU_MODE',
  'addCabinet'
);
